import { Pipe, PipeTransform } from '@angular/core';

/**
 * Adds colon to the given input.
 */
@Pipe({
  name: 'addColon'
})
export class AddColonPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return `${value}:`;
  }

}
